// Shared fetch wrapper for public API calls. Parses the standard error shape
// from server responses so thunks can surface friendly messages.
// Pass `body` as a plain object — it is JSON-stringified automatically.
// Pass `body` as a FormData instance to send multipart (no Content-Type set).
export const apiFetch = async (path, { body, headers, ...rest } = {}) => {
  const isJson = body != null && !(body instanceof FormData);
  const resp = await fetch(path, {
    headers: isJson ? { 'Content-Type': 'application/json', ...headers } : headers,
    body: isJson ? JSON.stringify(body) : body,
    ...rest,
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || `Request failed (${resp.status})`);
  }
  return resp.json();
};
